import { defineMessages } from 'react-intl';

const messages: {
	logoAlt: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	subtitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	connectButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	logoAlt: {
		id: 'post-office.rovo-chat.3p-connector-nudge.logo-alt',
		defaultMessage: '{appName} logo',
		description:
			'Alt text for the app logo in the 3P connector nudge banner. {appName} is the name of the app.',
	},
	heading: {
		id: 'post-office.rovo-chat.3p-connector-nudge.heading',
		defaultMessage: 'Your admin has added {appName}',
		description:
			'Heading text for the 3P connector nudge banner, telling the user their admin has added a third-party app. {appName} is the name of the app.',
	},
	subtitle: {
		id: 'post-office.rovo-chat.3p-connector-nudge.subtitle',
		defaultMessage: 'Connect your account to see more results',
		description:
			'Subtitle text for the 3P connector nudge banner, encouraging the user to connect their account.',
	},
	connectButton: {
		id: 'post-office.rovo-chat.3p-connector-nudge.connect-button',
		defaultMessage: 'Connect {appName}',
		description:
			'Button label for the 3P connector nudge banner CTA. {appName} is the name of the app to connect.',
	},
	dismissButton: {
		id: 'post-office.rovo-chat.3p-connector-nudge.dismiss-button',
		defaultMessage: 'Dismiss',
		description: 'Accessible label for the dismiss button on the 3P connector nudge banner.',
	},
});

export default messages;
